export const postBookingSurveyPageId = () => {
  return window.__mclean_env__.ENV === "production"
    ? "prod-capital-one-travel-web-embed"
    : "test-capital-one-travel-web-embed";
};
